import { render, staticRenderFns } from "./MainTemp.vue?vue&type=template&id=673e53cd&"
import script from "./MainTemp.vue?vue&type=script&lang=js&"
export * from "./MainTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports